import { createSelector } from 'reselect';
import { subselect } from './root';
import { propertiesSelector } from './properties';

const fetchByIdSelector = createSelector([propertiesSelector], ({ content }) => (id) =>
  content.clips && content.clips.find((item) => item._id === id),
);

export const viralfetchByIdSelector = subselect(fetchByIdSelector);
